import { supabase_guest } from "../supabase/supabaseClient";

export const fetchEventDetail = async (eventId) => {
  const { data, error } = await supabase_guest
    .from("event")
    .select("*")
    .eq("id", eventId)
    .single();

  if (error) {
    console.error("EVENT DETAIL ERROR:", error);
    return null;
  }

  return data;
};

export const fetchAttendance = async (eventId) => {
  const pageSize = 1000;
  const attendance = [];

  // Supabase limits a single response to max_rows (commonly 1,000). Fetching
  // consecutive ranges keeps the attendance list complete for larger events.
  for (let from = 0; ; from += pageSize) {
    const { data, error } = await supabase_guest
      .from("guest_attendance")
      .select(`
        id,
        seat_number,
        is_attend,
        attend_time,
        is_consumed,
        consumed_time,

        cluster:event_cluster (
          id,
          cluster_code
        ),

        guest_type:guest_type (
          id,
          name
        ),

        guest:guest (
          id,
          name,
          phone_number
        )
      `)
      .eq("event_id", eventId)
      .order("id", { ascending: true })
      .range(from, from + pageSize - 1);

    if (error) {
      console.error("fetchAttendance error:", error);
      return [];
    }

    attendance.push(...(data || []));

    if (!data || data.length < pageSize) break;
  }

  return attendance.sort((first, second) =>
    (first.guest?.name || "").localeCompare(second.guest?.name || "")
  );
};

export const fetchGuestTypes = async () => {
  const { data, error } = await supabase_guest
    .from("guest_type")
    .select("id, name")
    .order("name", { ascending: true });

  if (error) throw error;

  return data || [];
};

export const updateAttendanceGuestType = async (attendanceId, guestTypeId) => {
  const { data, error } = await supabase_guest
    .from("guest_attendance")
    .update({ guest_type_id: guestTypeId })
    .eq("id", attendanceId)
    .select("id, guest_type_id")
    .single();

  if (error) throw error;

  return data;
};

export const handleCheckIn = async (attendanceId) => {
  const { data, error } = await supabase_guest.rpc(
    "checkin_guest",
    {
      p_attendance_id: attendanceId,
    }
  );

  if (error) throw error;

  // PostgreSQL json can be returned as a string depending on the RPC response.
  const result = typeof data === "string" ? JSON.parse(data) : data;

  if (!result || result.status !== "success") {
    const status = result?.status || "checkin_failed";
    const messages = {
      attendance_not_found: "Data attendance tidak ditemukan.",
      already_checked_in: "Guest sudah pernah check-in.",
    };

    throw new Error(messages[status] || "Check-in tidak berhasil diproses.");
  }

  return result;
};

export const fetchAttendanceCount = async (eventId) => {
  const { count, error } = await supabase_guest
    .from("guest_attendance")
    .select("*", { count: "exact", head: true })
    .eq("event_id", eventId)
    .eq("is_attend", true);

  if (error) {
    console.error("fetchAttendanceCount error:", error);
    return 0;
  }

  return count;
};

export const fetchEventRundown = async (eventId) => {
  const { data, error } = await supabase_guest
    .from("event_rundown")
    .select(`
      id,
      start_time,
      end_time,
      schedule_name,
      schedule_description
    `)
    .eq("event_id", eventId)
    .order("start_time", { ascending: true });

  if (error) {
    console.error("fetchEventRundown error:", error);
    return [];
  }

  return data;
};

export const handleConsumptionCheck = async (attendanceId) => {
  console.log("handleConsumptionCheck called with attendanceId:", attendanceId);

  const { data, error } = await supabase_guest
    .from("guest_attendance")
    .update({
      is_consumed: true,
      consumed_time: new Date().toISOString(),
    })
    .eq("id", attendanceId)
    .select();

  if (error) {
    console.error("handleConsumptionCheck error:", error);
    throw error;
  }

  return data;
};
